import React, { useEffect, useState } from 'react';
import styles from './Agreement.module.scss';
import {
	clearAgreement,
	getAgreementDataById,
	goToStep,
	nextActiveStep,
	previousActiveStep,
	saveAgreementInfo,
	resetAgreement,
} from '../../redux/agreement/actions';
import { getLeadById } from '../../redux/deals/action';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid';
import StepBar from './StepBar/StepBar';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import ClientInfo from './ClientInfo/ClientInfo';
import ProductAvailability from './ProductAvailability/ProductAvailability';
import ReviewApsModal from './ReviewApsModal/ReviewApsModal';
import signDocument from '../../api/Agreement/helloSign/signDocument.api';
import OptionsPricing from './OptionsPricing/OptionsPricing';
import { useHistory, useParams } from 'react-router';
import { closeModal } from '../../redux/modals/action';
import { humanizer } from '../../utils/snakeCaseToHumanize';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Loading from '../layout/loading/Loading';
import { setAlert } from '../../redux/alerts/action';
import { setDealsSection } from '../../redux/deals/action';
import FloorplanModal from './ReviewApsModal/ReviewContent/ProductInformation/FloorplanModal/FloorplanModal';

const Agreement = ({
	stepbar,
	reviewAps,
	clearAgreement,
	agreementData,
	leadInfo,
	getAgreementDataById,
	saveAgreementInfo,
	loadedStepbar,
	goToStep,
	leadDetails,
	clientName,
	closeModal,
	firstName,
	lastName,
	resetAgreement,
	setAlert,
	setDealsSection,
	getLeadById,
	showFloorplanModal,
}) => {
	var params = useParams();
	var history = useHistory();
	const [clientInfoTab, setClientInfoTab] = useState();
	const [loading, setLoading] = useState();

	useEffect(() => {
		getAgreementDataById(params.id);
		getLeadById(params.id);
	}, []);

	useEffect(() => {
		if (agreementData) {
			if (
				agreementData?.totalOptions &&
				agreementData?.productAvailability &&
				agreementData?.clientInfo
			) {
				// to store option info when user clicks save & exit in last APS step
				goToStep(2);
			}
		}
		let tab = agreementData?.clientInfo?.corporation ? 1 : 0;
		setClientInfoTab(tab);
	}, [agreementData]);

	useEffect(() => {
		getAgreementDataById(params.id);
	}, [stepbar]);

	const Item = styled(Paper)(({ theme }) => ({
		...theme.typography.body2,
		padding: theme.spacing(1),
	}));

	useEffect(() => {
		return function cleanup() {
			clearAgreement();
			resetAgreement();
		};
	}, []);

	const navigation = () => {
		switch (stepbar) {
			case 0:
				return <ClientInfo defaultTab={clientInfoTab} />;
			case 1:
				return <ProductAvailability />;
			case 2:
				return <OptionsPricing />;
			default:
				break;
		}
	};

	const handleSignDocument = () => {
		console.log(
			'handleSignDocumenthandleSignDocument',
			params.id,
			leadDetails,
			agreementData,
			leadDetails
		);

		setLoading(true);

		signDocument(
			params.id,
			leadInfo,
			agreementData,
			leadDetails,
			(returned) => {
				setTimeout(() => {
					setLoading(returned);
				}, 2000);
			},
			(returned) => {
				history.push({
					pathname: returned,
					state: {
						from: 'agreement',
					},
				});
				setDealsSection('purchases');
			},
			(returned) => {
				setAlert('warning', returned);
			}
		);
		closeModal('reviewAps');
	};

	const handleFirstContactClick = (origin) => {
		const historyPush = (section) => {
			history.push({
				pathname: `/deals`,
			});
			setDealsSection(section);
		};
		if (origin === 'Purchasers') return historyPush('purchases');
		if (origin === 'Leads') return historyPush('leads');
	};

	return (
		<>
			{loading && <Loading />}
			<div className={styles.agreementWrapper}>
				<div className={styles.breadcrumb}>
					<div
						className={styles.firstContact}
						onClick={() =>
							handleFirstContactClick(
								history.location.state?.from
							)
						}
					>
						{`${humanizer(history?.location?.state?.from)}`}{' '}
					</div>
					<span>
						<KeyboardArrowRightIcon />
						{`${
							history.location.state?.from === 'Leads'
								? 'Start'
								: 'Continue'
						} agreement (APS)`}
					</span>
				</div>
				<div
					className={styles.header}
					style={{
						display: 'flex',
						alignItems: 'center',
						flexWrap: 'wrap',
						justifyContent: 'space-between',
					}}
				>
					<div className={styles.title}>Agreement (APS)</div>
					<div>
						<StepBar />
					</div>
					<div className={styles.clientName}>
						Client: {firstName + ' ' + lastName}
					</div>
				</div>

				<hr />

				{/* <Grid container spacing={2}> */}
				{/* <Grid item xs={3}>
						<Item>
							<StepBar />
						</Item>
					</Grid> */}
				<div>
					<Item>
						<div className={styles.contentWrapper}>
							{navigation()}
						</div>
					</Item>
				</div>
				{/* </Grid> */}

				<ReviewApsModal
					openModal={reviewAps}
					handleSignDocument={handleSignDocument}
					viewOnly={false}
				/>
				{showFloorplanModal && (
					<FloorplanModal openModal={showFloorplanModal} />
				)}
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	stepbar: state.agreementById?.stepbar || state?.agreement?.stepbar,
	reviewAps: state.modals.reviewAps,
	agreementData: state.agreement?.agreementById || state?.agreement,
	leadInfo: state.leads?.leadById || state.purchasers?.purchaserById,
	loadedStepbar: state.agreement?.agreementById?.stepbar,
	leadDetails: state.agreement?.agreementById?.leadDetails,
	firstName: state.leads?.leadById?.clientFName
		? state.leads?.leadById?.clientFName
		: state.agreement?.agreementById?.clientInfo?.firstName ||
		  state.agreement?.agreementById?.leadDetails?.clientFName,
	lastName: state.leads?.leadById?.clientLName
		? state.leads?.leadById?.clientLName
		: state.agreement?.agreementById?.clientInfo?.lastName ||
		  state.agreement.agreementById?.leadDetails?.clientLName,
	loading: state.agreement.loading,
	showFloorplanModal: state.modals.reviewFloorplans,
});

export default connect(mapStateToProps, {
	clearAgreement,
	getAgreementDataById,
	saveAgreementInfo,
	goToStep,
	closeModal,
	resetAgreement,
	setAlert,
	setDealsSection,
	getLeadById,
})(Agreement);
